const expressTypeArr = [
    {
        name: '快递',
        type: 'express_delivery_services'
    },
    {
        name: '快运',
        type: 'express_delivery_freights'
    },
    {
        name: '冷运',
        type: 'express_delivery_cold_chains'
    },
    {
        name: '医药',
        type: 'express_delivery_pharmaceuticals'
    },
    {
        name: '国际',
        type: 'express_delivery_internationals'
    }
]

export { expressTypeArr }



// WEBPACK FOOTER //
// ./src/pages/homePage/config.js